import { render, staticRenderFns } from "./MainAuthLayout.vue?vue&type=template&id=336dce30&scoped=true&"
import script from "./MainAuthLayout.vue?vue&type=script&lang=js&"
export * from "./MainAuthLayout.vue?vue&type=script&lang=js&"
import style0 from "./MainAuthLayout.vue?vue&type=style&index=0&id=336dce30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336dce30",
  null
  
)

export default component.exports